import "react-toastify/dist/ReactToastify.css";

import { Col, Row, Switch, Table, notification } from "antd";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { AntInput } from "../../../../../../shared/widges/antinput";
import { CoreServices } from "../../../../../../base/service/apiServices";
import { CustomQueueActions } from "../../../../../../store/slices/custom_queue_slice/custom_queue_slice";
import GetStart from "../../../../../login/getStart";
import Loader from "../../../../../../shared/widges/Loader/loader";
import Lottie from "lottie-react";
import NoDataFound from "../../../../../nodatafound/nodatafound";
import { WtButton } from "../../../../../../shared/widges/Button/button";
import _ from "lodash";
import loader6 from "../../../../../../styles/images/l6.json";
import { hassAccess, sortEnableQueueListArray } from "../../../../../../base/utils";
import styles from "./scss/customqueuelist.module.scss";
import { useDispatcher } from "../../../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { GetItemFromStorage } from "../../../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../../../custom_hooks/localStorageKeys";
import { ROLES } from "../../../../../../base/constant";

function QueueList() {
  const Table1: any = Table;
  const navigate = useNavigate();
  const initialSetupReducer: any = useSelector((state: any) => state.customQueue);
  const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  const [customQueueData, setCustomQueueData] = useState<any>([]);
  console.log("customQueueData------>>>>",customQueueData)
  const dataSource: any = customQueueData?.map(
    (call: any, index: any) => {
      return { ...call, key: index };
    }
  );
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState<any>("");
  const [expandedKeys, setExpandedKeys] = useState<any>([]);

  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  let supervisor = roleId && roleId.split(",").includes(ROLES.SUPERVISOR_ROLE_ID);
  let admin =
  roleId &&
  (roleId.split(",").includes(ROLES.ADMIN_ROLE_ID) ||
    roleId.split(",").includes(ROLES.SUB_OWNER_ROLE_ID) ||
    roleId.split(",").includes(ROLES.OWNER_ROLE_ID));
  const getParticularData = (selectedItem: any) => {
    navigate(`/customqueue/edit?qid=${selectedItem.qid}`);
  };
  const dispatch = useDispatcher();

  useEffect(() => {
    if (initialSetupReducer?.queueList?.length === 0) {
      setLoading(true);
      getList();
    } else {
      setCustomQueueData(initialSetupReducer.queueList);
      setLoading(false);
    }
    dispatch(
      CustomQueueActions.setupEdit({
        isEdit: false,
        editData: {},
        editDataName: "",
      })
    );
  }, []);
  let refreshIntervalId: any;

  const getList = () => {
    CoreServices.get("/get_queue_list")
      .then((value: any) => {
        if (value && value.data.statusCode === 200) {
          mapFunction(value.data.getQueueLists);
        } else if (value.data.statusCode === 404) {
          setLoading(false);
        }
      })
      .catch((err: any) => { });
  };

  const mapFunction = (value: any) => {
    const data: any = [];
    for (let list of value) {
      data.unshift({
        name: list?.name,
        description: list?.description,
        OutboundCallerId: list?.OutboundCallerId,
        outBoundNumber: list.outBoundNumber,
        maxCallHandlingTimeMM: list.maxCallHandlingTimeMM,
        maxCallHandlingTimeSS: list.maxCallHandlingTimeSS,
        callWrapUpTime: list.callWrapUpTime,
        businessHours: list.hours_of_operation,
        outBoundCallStatus: list.outBoundCallStatus,
        audio: list.settingAudio,
        announcement: list.announcement,
        maximumCallers: list.maximumCallers,
        maximumWaitTime: list.maximumWaitTime,
        qid: list.qid,
        status: list.status,
      });
    }
    setLoading(false);

    setCustomQueueData(data);
    setSearchData(data);

    dispatch(CustomQueueActions.queueList({ queueList: data }));

    doCallEnableQueue(data);
  };

  let enableArr: any = [];
  const doCallEnableQueue = (list: any) => {
    if (list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].status === 1) {
          enableArr.push(list[i]);
        }
      }
    }

    dispatch(CustomQueueActions.queueListEnable({ enableQueueList: enableArr }));

    clearInterval(refreshIntervalId);
  };
  const { t, i18n } = useTranslation();
  const columns1 = [
    {
      title: t("Queue Name"),
      dataIndex: "name",
      // width: "30%",
      render: (list: any, row: any) => (
        <span onClick={() => getParticularData(row)} className="linkText">
          {list}
        </span>
      ),
      sorter: (a: any, b: any) => {
        return a.name.localeCompare(b.name);
      },
    },
    {
      title: t("Description"),
      dataIndex: "description",
      // width: "50%",
      render: (list: any, row: any) => <span>{list ? list : "-"}</span>,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: t("Status"),
      dataIndex: "status",
      className:'smallcol',
      // width: "20%",
      //sorter: (a: any, b: any) => a.status - b.status,
      render: (status: any, row: any) => {
        return searchData && <Switch size="small" disabled={userRoleId!=3} checked={status === 0 ? false : true} onChange={() => toggleFormatterFunc(status, row)} />;
      },
    },
  ];

  const handleExpand = (expanded: boolean, record: any) => {
    setExpandedKeys(expanded ? [record.key] : []);
  };

  const mobilecolumn = [{
    title: t("Queue Name"),
    dataIndex: "name",
    render: (list: any, row: any) => (
      <span onClick={() => getParticularData(row)} className="linkText">
        {list}
      </span>
    ),
    sorter: (a: any, b: any) => {
      return a.name.localeCompare(b.name);
    },
  },Table.EXPAND_COLUMN]

  const createCustomQueue = () => {
    if(userRoleId==3)
    navigate("/customqueue");
  };

  const toggleFormatterFunc = (status: any, row: any) => {
    if (status === 0) {
      CoreServices.put({ status: 1 }, `/queue_update_status/${row.qid}`).then((response: any) => {
        const newStatusArr = [] as any;
        for (let data of customQueueData) {
          const tempData = { ...data };
          if (tempData.qid === row.qid) {
            newStatusArr.push({ ...tempData, status: 1 });
          } else {
            newStatusArr.push({ ...tempData });
          }
        }
        // let newStatusArr = customQueueData.map((resp: any) => {
        //   if (resp.qid === row.qid) {
        //     return { ...resp, status: 1 };
        //   }
        //   return resp;
        // });

        dispatch(CustomQueueActions.queueList({ queueList: newStatusArr }));
        setSearchValue("");
        sortEnableQueueListArray();

        notification.info({
          message: `${row.name} is enabled successfully`,
          placement: "topRight",
          className: "toastNotification success",
          icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000"/>
</svg>,
          closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676"/>
</svg>,
          duration: 3,
          top: 70,
        });
        setCustomQueueData(newStatusArr);
      });
    } else {
      CoreServices.get(`/check_queue_mapping/${row.qid}`).then((resp: any) => {
        if (resp.data.statusCode === 405) {
          CoreServices.put({ status: 0 }, `/queue_update_status/${row.qid}`).then((response: any) => {
            let newStatusArr = initialSetupReducer?.queueList?.map((resp: any) => {
              if (resp.qid === row.qid) {
                return { ...resp, status: 0 };
              }
              return resp;
            });
            dispatch(CustomQueueActions.queueList({ queueList: newStatusArr }));
            //  dispatch(CustomQueueActions.setupEdit({ queueList: newStatusArr }));
            // store.dispatch({
            //   type: Types.QUEUE_LIST,
            //   payload: {
            //     queueList: newStatusArr,
            //   },
            // });
            sortEnableQueueListArray();
            setSearchValue("");
            notification.info({
              message: `${row.name} is disabled successfully`,
              placement: "topRight",
              className: "toastNotification success",
              icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000"/>
</svg>,
              closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676"/>
</svg>,
              duration: 3,
              top: 70,
            });
            setCustomQueueData(newStatusArr);
          });
        } else {
          notification.info({
            message: ` Since the ${row.name} is mapped to the routing profile, it cannot be disabled at this time`,
            placement: "topRight",
            className: "toastNotification error",
            icon: <span className="icon__Error24" />,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
  <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676"/>
</svg>,
            duration: 3,
            top: 70,
          });
        }
      });
    }
  };

  const DoGlobalSearch = (e: any) => {
    setSearchValue(e.target.value);

    let searchText = e.target.value?.toLowerCase().trim();
    if (searchText.length === 0) {
      setCustomQueueData(initialSetupReducer.queueList);
    } else {
      let response: any = _.filter(initialSetupReducer.queueList, function (data: any) {
        let queueName = data?.name || "";
        return queueName?.toLowerCase().includes(searchText);
      });

      setCustomQueueData(response);
    }
  };

  const TableLoading = {
    spinning: loading,
    indicator: <Lottie className="tableLoader" animationData={loader6} />,
  };
  const planId = GetItemFromStorage(LocalStorage.PLAN_ID);
  const allowedPlanIds = [32,33,141, 42,55,56,57];
  const roleId1 = GetItemFromStorage(LocalStorage.ROLE_ID);
  const allowedRoleIds = ["3","5"];
  const planIdCheck = allowedPlanIds.includes(planId);
  const roleIdCheck = allowedRoleIds.includes(roleId1);
 
  useEffect(() => {
    if (!planIdCheck ||!roleIdCheck) {
      navigate(-1);
    }
  }, [planIdCheck, roleIdCheck, navigate]);
  return (
    <>
      {loading ? (
        <div className="centerlaytoutload">
          <Loader />
        </div>
      ) : (
        <>
          <div className="noFluid">
            <Row>
              <Col span={24}>
                <div>
                  <Row className="titleArea">
                    <Col sm={24}>
                      <h3>  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none"  onClick={()=> {navigate("/settingspage")}}>
                        <path d="M7.07327 16.4839C6.84187 16.4839 6.61037 16.395 6.43457 16.2183L0.916969 10.6665C-0.268531 9.47315 -0.269531 7.53085 0.915969 6.33745L6.43057 0.785646C6.78017 0.431146 7.35147 0.432146 7.70307 0.780746C8.05657 1.13135 8.05857 1.70065 7.70797 2.05325L2.19337 7.60505C1.70217 8.09915 1.70317 8.90295 2.19437 9.39705L7.71197 14.9488C8.06157 15.3013 8.06057 15.8717 7.70807 16.2222C7.53227 16.396 7.30277 16.4839 7.07327 16.4839Z" fill="#757676" />
                        </svg>{t("Custom Queues")}</h3>
                      <p className="witharrow">{t("A specialized queue for handling specific types of customer inquiries or tasks")}</p>
                    </Col>
                  </Row>
                  <div className={customQueueData?.length > 0 ? "boxWhite" : "boxWhite ifnoDataFound"}>

                      <div className={`topbarmain topbarmainlte`}>
                        <div className="topbarrowleft topbarmainlt">
                          <div className="inpelems">
                             <Col className="commontopbarsearch" >
                                              <AntInput className="tableSearch"  value={searchValue} placeHolder={t("Search name")} disabled={loading}  onChange={DoGlobalSearch}/>
                                            </Col>
                            {/* <AntInput value={searchValue} disabled={loading} className="tableSearch" placeHolder={t("Search")} onChange={DoGlobalSearch} /> */}
                          </div>
                        </div>
                        <div className="topbarright">
                          {admin &&  customQueueData?.length < 2 && hassAccess('settings/CreateQueue') ? <WtButton className="buttonGreenCreate" name={t("Create Queue")} onClick={createCustomQueue} /> : ""}
                        </div>

                      </div>
                    <div className="boxspacing boxspacingtabletop overflowlength">
                    {customQueueData?.length > 0 ? (
                      <>
                      <div className='desktoptablecontainer'>
                        <Table1
                          columns={columns1}
                          dataSource={customQueueData}
                          // locale={{
                          //   emptyText: (
                          //     <span>
                          //       <NoDataFound />
                          //     </span>
                          //   ),
                          // }}
                          bordered
                          className="borderedAntTable overflowscrollertableclass"
                          loading={TableLoading}
                          // loadingIndicator={(<Lottie className="svgLoadinglistcenter" animationData={loader6} style={{ "width": 150 }} />)}
                          showSorterTooltip={false}
                          pagination={customQueueData?.length < 10 ? false : { showSizeChanger: true }}
                          fixed={true}
                          tableLayout="fixed"
                        />
                      </div>
                      <div className='mobileresponsivetable'>
                        <Table1
                            columns={mobilecolumn}
                            dataSource={dataSource}
                            bordered
                            className="borderedAntTable"
                            loading={TableLoading}
                            showSorterTooltip={false}
                            pagination={false}
                            tableLayout="fixed"
                            expandable={{
                              expandedRowRender: (record: any , data:any) => {
                                return <div className="mobileviewdata">
                                  <p><strong>Description : </strong> {record.description ? record.description : "-"}</p>
                                  <p><strong>Status : </strong> {searchData && <Switch size="small" disabled={userRoleId!=3} checked={record.status === 0 ? false : true} onChange={() => toggleFormatterFunc(record.status, record)} />}</p>
                                </div>
                              },
                              expandedRowKeys: expandedKeys,
                              onExpand: handleExpand,
                              expandIcon: ({ expanded, onExpand, record }) => (
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onExpand(record, e);
                                  }}
                                  style={{ cursor: "pointer", fontSize: "16px",display: 'flex',alignItems: 'center',justifyContent: 'flex-end' }}
                                >
                                  <svg style={{
                                      transform: expanded
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="6"
                                    viewBox="0 0 12 6"
                                    fill="none"
                                  >
                                    <path
                                      d="M6.00155 5.90231C5.39905 5.90231 4.83355 5.66791 4.40825 5.24121L0.554751 1.37691C0.262251 1.08391 0.263251 0.609307 0.556251 0.316407C0.850151 0.024407 1.32525 0.0244068 1.61725 0.318407L5.47025 4.18271C5.75395 4.46591 6.24955 4.46591 6.53225 4.18271L10.3858 0.318407C10.6778 0.0245068 11.1529 0.024507 11.4468 0.316407C11.7398 0.609407 11.7407 1.08401 11.4483 1.37691L7.59475 5.24121C7.16945 5.66801 6.60365 5.90231 6.00155 5.90231Z"
                                      fill="#757676"
                                    />
                                  </svg>
                                </span>
                              ),
                            }}
                          />
                      </div>
                      </>
                      ) : (
                      <span>
                        <NoDataFound />
                      </span>
                    )}</div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
}
export { QueueList };
